export default __webpack_public_path__ + "static/media/July2014.f20b98e1.png";